// routes
import { PATH_DASHBOARD } from '../../../routes/paths';
// components

import SvgIconStyle from '../../../components/SvgIconStyle';
import { USER_ROLES } from '../../../constants/keywords';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
};

const navConfig = [
  // GENERAL
  {
    subheader: 'general',
    items: [
      {
        title: 'home',
        path: PATH_DASHBOARD.general.app,
        icon: ICONS.dashboard,
        roles: [USER_ROLES.ADMIN],
      },
    ],
    roles: [USER_ROLES.ADMIN],
  },

  {
    subheader: 'dashboard',
    items: [
      {
        title: 'home',
        path: PATH_DASHBOARD.general.userApp,
        icon: ICONS.dashboard,
        roles: [USER_ROLES.USER],
      },
    ],
    roles: [USER_ROLES.USER],
  },

  // MANAGEMENT
  {
    subheader: 'management',
    items: [
      {
        title: 'Users',
        path: PATH_DASHBOARD.users.list,
        icon: ICONS.user,
        // children: [{ title: 'List', path: PATH_DASHBOARD.users.list, roles: [USER_ROLES.ADMIN] }],
        roles: [USER_ROLES.ADMIN],
      },
      {
        title: 'Instructions',
        path: PATH_DASHBOARD.instructions.root,
        icon: ICONS.invoice,
        roles: [USER_ROLES.ADMIN],
      },
    ],
    roles: [USER_ROLES.ADMIN],
  },
];

export default navConfig;
